import React, { ReactElement } from 'react';

import { Route } from 'react-router-dom';

import { RouteType } from 'types/routeTypes';

export const renderRoutes = (route: RouteType, i: number): ReactElement => (
  <Route key={`${i}${route.path}`} path={route.path} element={route.element} />
);
